<app-employee-hr-certs-grid (mySelected)="grid_onSelected($event)"></app-employee-hr-certs-grid>

